/**
 * VConsole 调试工具：仅白名单账号登录后显示，便于 App 正式环境定向排查。
 */

/** @type {import('vconsole').default | null} */
let vConsoleInstance = null;

/**
 * 允许显示 VConsole 的手机号白名单（可按需追加）
 * @type {string[]}
 */
const VCONSOLE_ALLOW_PHONES = [
  '13777777777'
];

/**
 * 允许显示 VConsole 的 userCode 白名单（可按需追加）
 * @type {string[]}
 */
const VCONSOLE_ALLOW_USER_CODES = [];

/**
 * 从本地持久化读取当前登录用户标识
 * @returns {{ phone: string, userCode: string }}
 */
function getCurrentUserIdentity() {
  try {
    const raw = localStorage.getItem('userStore');
    if (!raw) {
      return { phone: '', userCode: '' };
    }
    const parsed = JSON.parse(raw);
    const userInfo = (parsed && parsed.userInfo) || {};
    return {
      phone: userInfo.userPhone ? String(userInfo.userPhone).trim() : '',
      userCode: userInfo.userCode ? String(userInfo.userCode).trim() : ''
    };
  } catch (e) {
    return { phone: '', userCode: '' };
  }
}

/**
 * 判断指定用户是否在 VConsole 白名单内
 * @param {{ phone?: string, userCode?: string }} [identity]
 * @returns {boolean}
 */
export function shouldEnableVConsole(identity) {
  const source = identity || getCurrentUserIdentity();
  const phone = source.phone ? String(source.phone).trim() : '';
  const userCode = source.userCode ? String(source.userCode).trim() : '';

  if (phone && VCONSOLE_ALLOW_PHONES.includes(phone)) {
    return true;
  }
  if (userCode && VCONSOLE_ALLOW_USER_CODES.includes(userCode)) {
    return true;
  }
  return false;
}

/**
 * 销毁 VConsole 实例
 */
function destroyVConsole() {
  if (vConsoleInstance && typeof vConsoleInstance.destroy === 'function') {
    vConsoleInstance.destroy();
  }
  vConsoleInstance = null;
}

/**
 * 解析 vconsole 动态 import 的构造函数（兼容 Webpack CJS / ESM 互操作）
 * @param {*} mod
 * @returns {Function|null}
 */
function resolveVConsoleConstructor(mod) {
  if (!mod) {
    return null;
  }
  const candidates = [
    mod,
    mod.default,
    mod.VConsole,
    mod.default && mod.default.default
  ];
  return candidates.find((item) => typeof item === 'function') || null;
}

/**
 * 按当前登录账号同步 VConsole 显示状态（登录/登出/切换账号后调用）
 * @param {{ userPhone?: string, userCode?: string }} [userInfo] 可选，优先使用该用户信息
 */
export function syncVConsole(userInfo) {
  const identity = userInfo
    ? {
        phone: userInfo.userPhone ? String(userInfo.userPhone).trim() : '',
        userCode: userInfo.userCode ? String(userInfo.userCode).trim() : ''
      }
    : getCurrentUserIdentity();

  const shouldEnable = shouldEnableVConsole(identity);

  if (process.env.NODE_ENV === 'development') {
    console.info('[VConsole]', shouldEnable ? '白名单命中' : '未命中白名单', identity);
  }

  if (!shouldEnable) {
    destroyVConsole();
    return;
  }

  if (vConsoleInstance) {
    return;
  }

  import('vconsole').then((mod) => {
    if (vConsoleInstance || !shouldEnableVConsole(identity)) {
      return;
    }
    const VConsole = resolveVConsoleConstructor(mod);
    if (!VConsole) {
      console.warn('[VConsole] 无法解析构造函数', mod);
      return;
    }
    vConsoleInstance = new VConsole();
  }).catch((err) => {
    console.warn('[VConsole] 加载失败', err);
  });
}



// WEBPACK FOOTER //
// ./src/utils/vconsole.js